<template>
    <!-- Ref: https://flowbite.com/docs/forms/checkbox/#disabled-state -->
    <div class="flex items-center gap-x-2">
        <input
            :id="inputId"
            type="checkbox"
            v-bind="$attrs"
            class="peer rounded-md border border-gray-400 disabled:bg-stone-100 disabled:text-gray-500 disabled:select-none disabled:cursor-not-allowed"
            :class="{
                'text-primary focus:ring-primary focus:ring-2':
                    !useBookingFormThemeCssVariables,
                'text-booking-form-theme-main-background-color focus:ring-booking-form-theme-main-background-color focus:ring-2':
                    useBookingFormThemeCssVariables,
            }"
            :checked="checked"
            @change="$emit('update:modelValue', !checked)"
            style="height: 1.4rem; width: 1.4rem; vertical-align: middle"
        />
        <label
            :for="inputId"
            class="text-gray-800 select-none peer-disabled:text-gray-400 peer-disabled:cursor-not-allowed"
        >
            <slot>
                {{ label }}
            </slot>
        </label>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import useId from '@/Shared/Hook/useId'

    defineOptions({
        inheritAttrs: false,
    })

    const props = defineProps({
        label: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            default: false,
        },
    })

    const inputId = ref(useId().make())
</script>
